import config from './config';

export function get_image_endpoint(companyAlias, imgType) {
  return config['LOGO_BASE_URL'] + companyAlias + '_' + imgType + '.png';
}
